<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="课程名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入课程名称" />
      </a-form-model-item>
      <a-form-model-item  prop="title" >

    <span slot="label" >课程标签：<span style='color:red'>(最多选7个标签)</span></span>

        <a-select
          mode="multiple"
          placeholder="全部"
          :value="banse_courseLabel"
          style="width: 100%"
          @change="setCourseList"
        >
          <a-select-option :value="item.name" v-for="(item, index) in courseLabelList" :key="item.id" >
            {{ item.name }}
          </a-select-option>
        </a-select>

      </a-form-model-item>
      <a-form-model-item label="课程讲师" prop="lecturer" >
        <a-input v-model="form.lecturer" placeholder="请输入课程讲师" />
      </a-form-model-item>
      <a-form-model-item label="副标题" prop="subtitle" >
        <a-input v-model="form.subtitle" placeholder="请输入副标题" />
      </a-form-model-item>
      <a-form-model-item label="课程类型 " prop="type" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.type">
          <a-radio :value=0>健身课程</a-radio>
          <a-radio :value=1>学院课程</a-radio>
        </a-radio-group>

      </a-form-model-item>
      <a-form-model-item label="课程等级" prop="level" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.level">
          <a-radio :value=0>入门</a-radio>
          <a-radio :value=1>初级</a-radio>
          <a-radio :value=2>中级</a-radio>
          <a-radio :value=3>高级</a-radio>
        </a-radio-group>

      </a-form-model-item>
      <a-form-model-item label="课程介绍" prop="introduce" >
        <a-input v-model="form.introduce" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
<!--      <a-form-model-item label="课程介绍图片" prop="introducePic" >-->
<!--        <file-upload v-model="form.introducePic" @input="getImg($event, 'img')" placeholder="请输入内容" type="image" />-->
<!--      </a-form-model-item>-->

      <a-form-model-item label="课程介绍图片" prop="introducePic">
        <file-upload type="image" :defaultList="form.imgArr1" :count="1"
                     @input="getImg($event, 'introducePic')"></file-upload>
      </a-form-model-item>


      <a-form-model-item label="课程背景图" prop="picture">
        <file-upload type="image" :defaultList="form.imgArr" :count="1"
                     @input="getImg($event, 'picture')"></file-upload>
      </a-form-model-item>


      <a-form-model-item label="课程金额"  v-if="form.type == 1" prop="money" >
        <a-input v-model="form.money" v-if="form.type == 1" placeholder="请输入课程金额" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {getCourse, addCourse, updateCourse, labelCourse} from '@/api/course/course'
import {guid} from "@/utils/ruoyi";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      banse_courseLabel:[],
      base_courseLabelList:[],
      // courseLabelList:[],
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        imgCount: 1,
        imgArr: [],

        name: null,

        title: null,

        lecturer: null,

        subtitle: null,

        type: null,

        level: null,

        introduce: null,

        introducePic: null,

        picture: null,

        money: null,

        people: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        name: [
          { required: true, message: '课程名称不能为空', trigger: 'blur' }
        ],
        // title: [
        //   { required: true, message: '课程标签不能为空', trigger: 'blur' }
        // ],
        lecturer: [
          { required: true, message: '课程讲师不能为空', trigger: 'blur' }
        ],
        subtitle: [
          { required: true, message: '副标题不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '课程类型 0-健身课程 1-学院课程 2-创作者课程不能为空', trigger: 'change' }
        ],
        level: [
          { required: true, message: '课程等级 0-入门 1-初级 2-中级 3-高级不能为空', trigger: 'blur' }
        ],
        introduce: [
          { required: true, message: '课程介绍不能为空', trigger: 'blur' }
        ],
        introducePic: [
          { required: true, message: '课程介绍图片不能为空', trigger: 'blur' }
        ],
        // picture: [
        //   { required: true, message: '课程背景图不能为空', trigger: 'blur' }
        // ],
        money: [
          { required: true, message: '课程金额不能为空', trigger: 'blur' }
        ],

      }
    }
  },
  filters: {
  },
  created () {
    // 从接口拿到数据后，进行数据处理，如果你的参数名是img 增加2个参数 imgCount、imgArr
    // this.form.imgCount = 2
    // this.form.img = '2023/08/19/9a0f7629-5bbe-489c-9af3-a85c235bdf2f.png'
    // this.form.picture = this.form.picture
    // this.form.imgArr = this.setImgData('picture', this.form.picture)
    //
    // this.form.videoCount = 1
    // this.form.video = '2023/08/15/180313109-compose.mp4'
    // this.form.videoArr = this.setImgData('video', this.form.video)
    console.log('form', this.form)
  },
  computed: {
    courseLabelList() {
      return this.base_courseLabelList.filter(o => !this.banse_courseLabel.includes(o.name));
    },
    courseLabel() {
      return this.base_courseLabelList.filter(o => this.banse_courseLabel.includes(o.name)).map(item=>item.id)
    },
  },
  watch: {
  },
  mounted () {
  },
  methods: {

    filterOption(input, option) {
      // 重点在这
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    onClose () {
      this.reset()
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.reset()
      this.open = false
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.courseLabel = [],
      this.banse_courseLabel = [],
      this.form = {
        id: null,
        imgArr: [],
        imgArr1: [],
        name: null,
        title: null,
        lecturer: null,
        subtitle: null,
        type: 0,
        level: 0,
        introduce: null,
        introducePic: null,
        picture: null,
        money: null,
        people: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.open = true
      this.reset()
      this.formType = 1
      this.formTitle = '添加'
      this.getCourseList()
    },

    //设置多选值
    setCourseList(selectedItems) {
      // console.log(selectedItems)
      this.banse_courseLabel = selectedItems;
      if(this.banse_courseLabel.length>7){
        this.$message.error("课程标签不能超过7个")
        this.banse_courseLabel.splice(-1, 1)
      }
      //这是最终要提交的地址
      console.log(this.courseLabel)
    },
    /** 查询标签名称 */
    getCourseList() {
      labelCourse({type:0}).then(Response => {
          console.log(Response)
          this.base_courseLabelList = Response.data;
        }
      )
    },


    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.getCourseList(row, ids);
      this.open = true
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCourse({"id":id}).then(response => {
        this.form = response.data

        let that = this;
        this.form.imgArr = []
        this.form.imgArr.push({
          uid: guid(8, 10),
          name: that.form.picture,
          status: 'done',
          halfUrl: that.form.picture,
          url: that.form.picture,
          path: that.form.picture
        })

        this.form.imgArr1 = []
        this.form.imgArr1.push({
          uid: guid(8, 10),
          name: that.form.introducePic,
          status: 'done',
          halfUrl: that.form.introducePic,
          url: that.form.introducePic,
          path: that.form.introducePic
        })

        this.open = true
        this.formTitle = '修改'
       //  修改回显:
        let tem_arr = this.form.title.split(",");
        this.banse_courseLabel = this.base_courseLabelList.filter(o => tem_arr.includes(o.id)).map(item=>item.name)

        console.log(this.form)

      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true

          // this.form.introducePic = this.form.imgArr.map(e =>{
          //   return e.
          // })


          this.form.title = this.courseLabel.join(",")

          if (this.form.id !== undefined && this.form.id !== null) {
            updateCourse(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCourse(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },

    /******************** 上传图片数据处理 start ********************/
    /**前端 需要将图片格式处理成数组，方便数据回显 */
    setImgData(field, img) {
      let fieldImgArr = []
      if (img.indexOf(",") === -1) {
        // 单图
        if (this.form[`${field}Count`] === 1) {
          if (img) {
            fieldImgArr.push({
              uid: guid(8, 10),
              name: img,
              status: 'done',
              halfUrl: img,
              url: img,
              path: img
            })
          }
        }
      } else {
        // 多图
        if (this.form[`${field}Count`] > 1) {
          let imgArr = img.split(",")
          if (imgArr.length) {
            imgArr.map(item => {
              fieldImgArr.push({
                uid: guid(8, 10),
                name: img,
                status: 'done',
                halfUrl: img,
                url: item,
                path: item
              })
            })
          }
        }
      }
      return fieldImgArr
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    },
    /** 点击视频 弹窗打窗口播放视频*/
    async handlePreview(file) {
      this.previewImage = this.form.video || file.video;
      this.previewVisible = true;
      this.$nextTick(() => {
        this.$refs.myVideo.play()
      })
    },
    handleCancel() {
      this.previewVisible = false;
    },
    /******************** 上传图片数据处理 end   ********************/


  }
}
</script>
<style lang="less">
.imgbox {
  overflow: hidden;
  background-color: #f7f7f7;
  position: relative;
  cursor: pointer;

  width: 104px;
  height: 104px;
  margin: 0 8px 8px 0;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
}

.videomask {
  position: absolute;
  z-index: 10;
  width: 100px;
  height: 100px;
  margin: 0 auto;
  line-height: 100px;
  background: rgba(0, 0, 0, .3);
  text-align: center;

  .icon {
    display: inline-block;
    font-size: 26px !important;
    color: #fff !important;
  }
}
</style>